import React from 'react';

export const AlertCircle = () => (
    <>
        <circle cx='12' cy='12' r='9' />
        <line x1='12' y1='8' x2='12' y2='12' />
        <line x1='12' y1='15' x2='12' y2='16' />
    </>
);